export default __webpack_public_path__ + "static/media/comingsoon.e7ef6841.png";